/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pb_ExamplesInputs */

const en_pb_examples = /** @type {(inputs: Pb_ExamplesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Things you can ask for`)
};

const id_pb_examples = /** @type {(inputs: Pb_ExamplesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contoh yang bisa Anda minta`)
};

/**
* | output |
* | --- |
* | "Things you can ask for" |
*
* @param {Pb_ExamplesInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pb_examples = /** @type {((inputs?: Pb_ExamplesInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pb_ExamplesInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pb_examples(inputs)
	return en_pb_examples(inputs)
});